// Thin re-export of axios. The wrapper exists so the underlying HTTP
// client can be upgraded (axios 0.21 -> 0.31+ — see SS-1544) or swapped
// without touching every call site. Keep the surface minimal: no global
// interceptors, default headers, or transforms here unless they apply
// to every axios usage in the app.
import axios from 'axios'

export default axios
